import useQuestionSettingsField from '@v4/hooks/questions/useQuestionSettingsField'
import { useCallback, useEffect, useState } from 'react'
import useStyles from './Numeric.styled'

export const useNumeric = ({ withBgImage, justify, pending, answers, onClick }) => {
	const allowDecimals = useQuestionSettingsField('allow_decimals')
	const min = useQuestionSettingsField('min')
	const max = useQuestionSettingsField('max')
	const [value, setValue] = useState(() => _.get(answers, [0, 'answer']) ?? '')
	const classes = useStyles()

	const handleChange = useCallback(event => {
		const newValue = event.target.value
		setValue(newValue)
	}, [])

	const handleSubmit = useCallback(() => {
		onClick?.({ answer: value })
	}, [onClick, value])

	useEffect(() => {
		const handleKeyUp = event => {
			if (event.key === 'Enter') handleSubmit()
		}

		document.addEventListener('keyup', handleKeyUp)
		return () => {
			document.removeEventListener('keyup', handleKeyUp)
		}
	}, [handleSubmit])

	return [
		{
			classes,
			withBgImage,
			justify,
			allowDecimals,
			pending,
			value,
			amount: `${min} – ${max}`,
			min,
			max,
		},
		{ handleChange, handleSubmit },
	]
}
